(function ($) {
	// Elements
	let $filters_form = $('.archive-product-filters'),
		$loading = $('.archive-product__loading'),
		$footer = $('.products_archive__footer')


	// Ajax base URL
	var baseUrl = $filters_form.attr('action');

	// Prevent filters spam
	var request
	var lastRequest
	var timeout

	//
	var loading_next_page = false

	// Returns all active filters
	function get_active_filters() {

		// Get data from form
		var form_data = $filters_form.eq(0).serializeArray()

		// Reset filters object
		let filters = {}

		form_data.forEach(function (item) {

			// Skip empty values
			if (!item.value) {
				return
			}

			// Set price_from & price_to only if less/greater than min (default) value
			if (item.name == 'price_from') {
				if (item.value > parseInt($("input[name='price_from']").attr('min'))) {
					filters[item.name] = item.value
				}
			} else if (item.name == 'price_to') {
				if (item.value < parseInt($("input[name='price_to']").attr('max'))) {
					filters[item.name] = item.value
				}
			} else if (filters[item.name]) {
				// Set 2nd and next value
				filters[item.name] += "," + item.value
			} else {
				// Set 1st value
				filters[item.name] = item.value
			}
		})

		return filters
	}

	$filters_form.change(function () {

		// Clear timeout to prevent spam
		clearTimeout(timeout)

		remove_products()
		show_loading()

		// Abort previous request if is loading
		if (typeof request !== "undefined") {
			request.abort()
		}

		// Wait 0,5sec - prevent request spam caused by fast clicks etc. in filters
		timeout = setTimeout(() => {
			load_products(get_new_url(), false)
		}, 500)

	})

	function remove_products() {
		$('.products_archive__products').empty()
	}

	function show_loading() {
		$(".products_archive__filter-count").html('&nbsp;')
		$loading.show()
		$footer.hide();
	}

	function hide_loading() {
		$loading.hide()
	}

	function init_load_more_button() {
		let $load_more_button = $('#archive-product-load-more')
		$load_more_button.click(function (e) {
			e.preventDefault()

			if (loading_next_page) {
				return
			}
			loading_next_page = true

			show_loading()
			load_products($(this).attr('href'), true)
		})
	}

	function get_new_url(base = false) {

		let url = base ? base : baseUrl,
			first = true,
			filters = get_active_filters()

		// Add filters if set
		if (filters) {
			for (const [key, value] of Object.entries(filters)) {
				if (first) {
					first = false
					url += "?"
				} else {
					url += "&"
				}

				url += key + "=" + value
			}
		}

		// // Ordering
		// var active_filter = $('.orderby_option.active').data('order-by')
		//
		// if (active_filter && active_filter !== 'relevance' && active_filter !== 'menu_order') {
		// 	if (first) {
		// 		url += "?"
		// 	} else {
		// 		url += "&"
		// 	}
		//
		// 	url += "orderby=" + active_filter
		// }

		return url;
	}

	function update_url(url) {
		window.history.replaceState({Url: url}, "", url);
		return url
	}

	function load_products(url, append) {

		// add wc-ajax to target url
		var target = url + (url.includes('?') ? '&' : '?') + 'gp-ajax=product_archive';

		// Abort previous request if is loading
		if (typeof request !== "undefined") {
			request.abort()
		}

		request = gp_ajax({
			url: target,
			type: "post",
			dataType: 'json',
			data: {append: append},
		})

		// success
		request.done(function (response, textStatus, jqXHR) {

			// Change url
			update_url(url);

			// Bind javascript on new added products
			// init_variations()
			init_load_more_button()

			$(document).trigger("ajax_products_loaded")

		});

		request.always(function () {
			loading_next_page = false
			hide_loading()
		})


		// // Add wc-ajax to target url
		// var target = url + (url.includes('?') ? '&' : '?') + 'wc-ajax=product_archive';
		//
		// // Do request
		// request = $.ajax({
		// 	url: target,
		// 	type: "post",
		// 	dataType: 'json',
		// 	data: {
		// 		url: url,
		// 		append: append
		// 	},
		// });
		//
		// lastRequest = request;
		//
		// // On success
		// request.done(function (response, textStatus, jqXHR) {
		//
		// 	let success = response.success,
		// 		data = response.data
		//
		// 	if (request !== lastRequest || !success) {
		// 		return;
		// 	}
		//
		// 	// Fragments
		// 	// Replace
		// 	if (typeof data.fragments.replace != "undefined") {
		// 		$.each(data.fragments.replace, (key, value) => {
		// 			$(key).replaceWith(value)
		// 		})
		// 	}
		//
		// 	// Append
		// 	if (typeof data.fragments.append != "undefined") {
		// 		$.each(data.fragments.append, (key, value) => {
		// 			$(value).children().appendTo(key)
		// 		})
		// 	}
		//
		// 	// DataLayer - push viewed products loaded via AJAX
		// 	if (typeof data.fragments.append[".products_archive__items"] != "undefined") {
		// 		let loaded_products = $(data.fragments.append[".products_archive__items"])
		//
		//
		// 		if (loaded_products) {
		// 			let pagenum = 1
		// 			if (typeof data.pagenum !== "undefined") {
		// 				pagenum = data.pagenum
		// 			}
		//
		// 			let product_list_items = []
		// 			$("div.products_item[data-layer-product]", loaded_products).each(function () {
		// 				let product_list_item_dl = $(this).attr('data-layer-product')
		// 				if (product_list_item_dl.length > 0) {
		// 					let product_list_item = $.parseJSON(product_list_item_dl)
		// 					product_list_item["index"] = (pagenum - 1) * 12 + product_list_item["index"]
		// 					product_list_items.push(product_list_item)
		// 				}
		// 			})
		//
		// 			if (product_list_items.length > 0) {
		// 				$(document).trigger("ghostpress-ajax-products-loaded", [product_list_items])
		// 			}
		// 		}
		// 	}
		//
		// 	// Change url
		// 	update_url(url);
		//
		// 	init_load_more_button()
		// 	$(document).trigger("ajax_products_loaded")
		//
		// });
		//
		// // On fail
		// request.fail(function (response, textStatus, jqXHR) {
		// 	// return false;
		// });
		//
		// // Do always
		// request.always(function () {
		// 	if (request !== lastRequest) {
		// 		return;
		// 	}
		// 	loading_next_page = false
		// 	hide_loading()
		// })

	}

	// On DOM ready
	init_load_more_button()

})(jQuery);